import { useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import useSearch from "hooks/useSearch";
import { Link } from "react-router-dom";
import { searchByProp } from "utils/search";
import { FETCH_STOCK_SUPPLIERS } from "./graphql";

const SuppliersPage = () => {
  const { loading, error, data } = useQuery(FETCH_STOCK_SUPPLIERS);
  const [q, setQ] = useSearch();

  if (loading) return <Spinner />;
  if (error) return <Errors error={parseError(error)} />;

  const suppliers = (data?.suppliers || [])
    .filter((i) => searchByProp(i, ["nickName"], q))
    .map((supplier) => ({ ...supplier, name: supplier.nickName || "" }));

  return (
    <div className="flex-1 overflow-auto flex flex-col p-6">
      <div>
        <SearchBar
          value={q}
          onChange={setQ}
          placeholder="Search suppliers..."
        />
      </div>

      <div className="p-0 card flex-1 overflow-auto flex flex-col mt-4">
        <div className="flex-1 overflow-auto relative">
          <table>
            <tbody>
              {suppliers.map((supplier) => (
                <tr
                  key={supplier.id}
                  className="font-normal border-b border-gray-100 dark:border-gray-700"
                >
                  <td className="font-semibold text-gray-800 dark:text-gray-100">
                    <Link className="px-2" to={supplier.id}>
                      {supplier.nickName || "-"}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SuppliersPage;
